import { marginLeft } from '@/utils/directions';
import { colorAccent, colorWhite } from '@/utils/palette';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BadgeWrapper = styled.span`
  background: ${colorAccent};
  color: ${colorWhite};
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  ${marginLeft}: 5px;
  text-transform: uppercase;
`;

const SidebarBadge = ({ text }) => {
  return <BadgeWrapper> {text}</BadgeWrapper>;
};

SidebarBadge.propTypes = {
  text: PropTypes.string.isRequired,
};

export default SidebarBadge;
